// @flow
import update from 'immutability-helper';

function sequenceItemsMap(items: *): Map<string, *> {
  return new Map(items.map(item => [item.item.uuid, item]));
}

export function removeSequenceItemsFromQueryResult(result: *, sequenceItemsUUIDs: Array<string>) {
  const items = result.chatStreams[0].sequenceItems.filter(sequenceItem => {
    return !sequenceItemsUUIDs.includes(sequenceItem.item.uuid);
  });

  return update(result, {
    chatStreams: {
      '0': { sequenceItems: { $set: items } },
    },
  });
}

export function addSequenceItemsToQueryResult(result: *, newSequenceItems: *) {
  const oldItems = sequenceItemsMap(result.chatStreams[0].sequenceItems);
  const newItems = sequenceItemsMap(newSequenceItems);

  const mergedMap = new Map([...oldItems, ...newItems]);
  const mergedArray = Array.from(mergedMap.values());

  const sortedArray = mergedArray.sort((a, b) => {
    if (Number(a.seq) > Number(b.seq)) {
      return -1;
    }

    if (Number(a.seq) < Number(b.seq)) {
      return 1;
    }

    return 0;
  });

  return update(result, {
    chatStreams: {
      '0': { sequenceItems: { $set: sortedArray } },
    },
  });
}
